import { render } from "./PersistentTooltip.vue?vue&type=template&id=cede39a6&lang=pug"
import script from "./PersistentTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./PersistentTooltip.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__